/**
 * Returns the correct "home" route for the current user:
 *   • staff (admin / manager / team) → /staff (Staff Dashboard)
 *   • installers & everyone else     → /   (Installer / public Home)
 *
 * Used by every page that has a Back-to-home button so staff aren't
 * dropped onto the installer landing view.
 */
import { useContext } from 'react';
import AuthContext from '@/contexts/AuthContext';

export default function useHomePath() {
  const { user } = useContext(AuthContext);
  if (user?.role === 'affiliate') return '/affiliate';
  return ['admin', 'manager', 'team'].includes(user?.role) ? '/staff' : '/';
}
